/*
 * @Author: Wang_jun 1433207604@qq.com
 * @Date: 2022-03-02 15:28:27
 * @LastEditors: Wang_jun 1433207604@qq.com
 * @LastEditTime: 2024-05-09 17:18:35
 * @FilePath: /visaai-platform/src/plugins/store/modules/userInfo.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { SET_USER_INFO,SET_DOWNLOAD_NUM } from '../types'

const state = {
  data: {},
  downloadNum:0,
}

const mutations = {
  [SET_USER_INFO](state, data) {
    state.data = data
  },
  [SET_DOWNLOAD_NUM](state, data) {
    state.downloadNum = data
    console.log(state,'state')
  }
}

export default { state, mutations }
